import { Button, Col, Row } from "antd";
import "../App.css";
import { ReactComponent as TDLogo } from "../Icons/transdyne-01.svg";
import bgimg from "../images/Hero-image-V1.png";
import { useEffect } from "react";

export const Login = ({ onLogin }: { onLogin: () => void }) => {

  useEffect(() => {
      document.body.classList.toggle("no-scroll", !(window.innerWidth <= 767));
  }, []);

  return (
    <Row className="row">
      <Col
        xs={24}
        sm={24}
        md={14}
        lg={14}
        xl={14}
        className="left-col"
        ></Col>

      <Col
        xs={24}
        sm={24}
        md={10}
        lg={10}
        xl={10}
        className="right-col"
        >
        <TDLogo className="login-logo" style={{marginBottom:"2.5rem"}}/>
        <div className="wrap-text font-1212">
          Revolutionizing Healthcare Documentation with Virtual Scribing Solution
        </div>
        <Button
          type="primary"
          onClick={onLogin} className="button-login">
          Login
        </Button>
      </Col>
    </Row>
  );
};
